export default "__VITE_ASSET__BdEm7nOu__"